/* eslint-disable import/no-anonymous-default-export */
import reportServices from '../services/Reports';

const clientDataLogic = async (paremeters, businessModueId, year) => {
    const dataResp = await reportServices.clientData(paremeters, businessModueId, year);
    return dataResp;
}

const clientDataByMonthLogic = async (page, perPage, search, paremeters, businessModueId, month, year) => {
    const dataResp = await reportServices.clientDataByMonth(page, perPage, search, paremeters, businessModueId, month, year);
    return dataResp;
}

const earnsDataLogic = async (paremeters, businessModueId, month, year) => {
    const dataResp = await reportServices.earnData(paremeters, businessModueId, month, year);
    return dataResp;
}

const eransDataByMonthLogic = async (paremeters, businessModueId, month, year, page, perPage, search) => {
    const dataResp = await reportServices.earnDataByMonth(paremeters, businessModueId, month, year, page, perPage, search);
    return dataResp;
}

const statusDataLogic = async (paremeters, businessModueId, month, year) => {
    const dataResp = await reportServices.statusData(paremeters, businessModueId, month, year);
    return dataResp;
}

const statusDataDonutLogic = async (paremeters, businessModueId, service, year) => {
    const dataResp = await reportServices.statusDataDonut(paremeters, businessModueId, service, year);
    return dataResp;
}

export default {
    clientDataLogic,
    clientDataByMonthLogic,
    earnsDataLogic,
    eransDataByMonthLogic,
    statusDataLogic,
    statusDataDonutLogic
}
